const RidesReducer = (state, action) => {
    switch (action.type) {

        case "GET_RIDES_START":
            return {
                ...state,
                isFetching: true,
                error: false,
            };

        case "GET_RIDES_SUCCESS":
            return {
                ...state,
                rides: action.payload,
                isFetching: false,
                error: false,
                hasFetched: true,
            };

        case "GET_RIDES_FAILURE":
            return {
                ...state,
                isFetching: false,
                error: true,
                hasFetched: false,
            };

        default:
            return state;
    }
};

export default RidesReducer;